// userStore.ts
import { atom } from 'jotai';
import { IUserRootResponse } from '../types/user';

// User data atom
export const userDataAtom = atom<IUserRootResponse | null>(null);

// User loading state atom
export const userLoadingAtom = atom<boolean>(false);

// User error state atom
export const userErrorAtom = atom<string | null>(null);

// Derived atom for user data with loading and error states
export const userStateAtom = atom(
  (get) => ({
    data: get(userDataAtom),
    loading: get(userLoadingAtom),
    error: get(userErrorAtom),
  }),
  (get, set, newData: IUserRootResponse | null) => {
    set(userDataAtom, newData);
    set(userErrorAtom, null); // Clear error when setting new data
  }
);

// Action atom to set loading state
export const setUserLoadingAtom = atom(
  null,
  (get, set, loading: boolean) => {
    set(userLoadingAtom, loading);
  }
);

// Action atom to set error state
export const setUserErrorAtom = atom(
  null,
  (get, set, error: string | null) => {
    set(userErrorAtom, error);
    set(userLoadingAtom, false); // Stop loading when error occurs
  }
);

// Action atom to clear user data
export const clearUserDataAtom = atom(
  null,
  (get, set) => {
    set(userDataAtom, null);
    set(userErrorAtom, null);
    set(userLoadingAtom, false);
  }
);
